import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigService } from "../shared/utils/config.service";
import { TzadikimModel } from "../models/tz.model";
import { map, Observable } from 'rxjs';

@Injectable()
export class TzadikimService {

    baseUrl: string = '';

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.baseUrl = configService.getApiURI();
    };

    getTzadikim() {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/tzadikims', { headers: headers })
            .pipe(map((res :any) => {
                return res;
            }));
    }

    getTzMkmId(id: number) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/tzmkm/' + id, { headers: headers })
            .pipe(map((res :any) => {
                return res;
            }));
    }

    getTzadikimWeb(filter:string) {

        return this.http.get(this.baseUrl + '/tzadikimweb?filter=' + filter)
            .pipe(map((res :any) => {
                return res;
            }));
    }
    addImageIntoTzadik(mkmId: number, image: File): Observable<any> {
        const formData = new FormData();
        formData.append('MkmId', mkmId.toString());
        formData.append('Image', image);

        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers);

        return this.http.post(this.baseUrl + '/mkms/addimage', formData, { headers: headers })
            .pipe(map((res: any) => {
                console.log(res,"Response after api call")
                return res;
            }));
    }

    getTzadik(id: number) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/tzadikims/' + id, { headers: headers })
            .pipe(map((res :any) => {
                return res;
            }));
    }

    create(tz: TzadikimModel) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.post(this.baseUrl + '/tzadikims', tz, { headers: headers })
            .pipe(map((res :any) => {
                return res;
            }));
    }

    update(tz: TzadikimModel) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.put(this.baseUrl + '/tzadikims/' + tz.id, tz, { headers: headers })
            .pipe(map((res :any) => {
                return res;
            }));
    }

    delete(id: number) {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)

        return this.http.delete(this.baseUrl + '/tzadikims/' + id, { headers: headers })
            .pipe(map((res :any) => {
                return res;
            }));
    }

}